import { isValidActionName as u } from "@coldwired/actions";
import { parseHTMLFragment as s } from "@coldwired/utils";
var p = process.env.NODE_ENV === "production", o = "Invariant failed";
function n(e, t) {
  if (!e) {
    if (p)
      throw new Error(o);
    var r = typeof t == "function" ? t() : t, a = r ? "".concat(o, ": ").concat(r) : o;
    throw new Error(a);
  }
}
async function T(e, t) {
  e.applyActions(
    [...s(t, e.element.ownerDocument).children].map(l)
  ), await e.ready();
}
function l(e) {
  n(e.tagName == "TURBO-STREAM", "[turbo-stream] element must be a <turbo-stream>");
  const t = f(e), r = d(e), a = m(e), i = b(e), c = g(e);
  switch (t) {
    case "after":
    case "before":
    case "update":
    case "replace":
    case "append":
    case "prepend":
      return n(c, "[turbo-stream] template is required"), { action: t, delay: r, pin: a, targets: i, fragment: c };
    default:
      return { action: t, delay: r, pin: a, targets: i };
  }
}
function f(e) {
  const t = e.getAttribute("action");
  return n(u(t), `[actions] action "${t}" is not supported`), t;
}
function m(e) {
  const t = e.getAttribute("pin");
  if (t == "" || t == "true")
    return !0;
  if (t == "last")
    return "last";
}
function d(e) {
  const t = e.getAttribute("delay");
  if (t)
    return parseInt(t);
}
function b(e) {
  const t = e.getAttribute("target"), r = e.getAttribute("targets");
  return n(r || t, '[turbo-stream] "target" or "targets" attributes are required'), r || `#${t}`;
}
function g(e) {
  const t = e.firstElementChild;
  if (!t)
    return;
  n(
    t instanceof HTMLTemplateElement,
    "[turbo-stream] first child element must be a <template> element"
  );
  const r = t.content;
  return r.normalize(), r;
}
export {
  l as parseTurboStream,
  T as renderTurboStream
};
